<template>
    <div
        class="toolbar-button">
        <Icon :svg="icon" />
        <span> {{ label }} </span>
    </div>
</template>

<script>

import Icon from './Icon';

export default {
    name: 'ToolbarButton',

    components: {
        Icon
    },

    props: {
        icon: {
            type: String,
            required: true
        },

        label: {
            type: String,
            required: true
        }
    }
};
</script>

<style scoped>
    .toolbar-button {
        display: inline-flex;
        align-items: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/ToolbarButton.vue